import * as React from "react"
import { Box, Button } from "./ui"

import { modal, modalActive, modalButton, modalContent } from "./modal.css"
import { X } from "react-feather"
import ActivecampaignModal from "./activecampaign-modal"

export default function Modal() {
  const [show, setShow] = React.useState(false)
  const [content, setContent] = React.useState(null)
  const [shown, setShown] = React.useState(false)

  const handleClose = () => {
    setShow(false)
    setContent(null)
  }

  const handleOpen = (content) => {
    setShow(true)
    setContent(content)
    setShown(true)
  }

  React.useEffect(() => {
    if (!show && !shown) {
      const timeout = setTimeout(() => {
        handleOpen(<ActivecampaignModal />)
      }, 120000)
      return () => clearTimeout(timeout)
    }
  }, [show, shown])

  React.useEffect(() => {
    if (show) {
      document.body.style.overflow = "hidden"
      const handleClick = (e) => {
        if (e.target.classList.contains(modalActive)) {
          handleClose()
        }
      }
      document.addEventListener(`click`, handleClick)
      return () => {
        document.removeEventListener(`click`, handleClick)
        document.body.style.overflow = "auto"
      }
    }
  }, [show, shown])

  return (
    <>
      <Box className={show ? modalActive : modal}>
        {show && (
          <Box className={modalContent}>
            {content}
            <Button
              className={modalButton}
              aria-label="close modal"
              onClick={(e) => {
                e.preventDefault()
                handleClose()
              }}
            >
              <X size={24} color={"black"} />
            </Button>
          </Box>
        )}
      </Box>
    </>
  )
}
